import { Space } from 'antd'
import { useCIMSNotificationsPanelContext } from 'components/CIMSNotifications/components/CIMSNotificationsPanelContext'
import { useIssueNotificationsContext } from '../../IssueNotificationsContext'
import RecipientsTags from 'components/CIMSTags/common/RecipientsTags'
import CIMSCollapse from 'components/CIMSCollapse'
import { alphabeticalSort } from '@cims-online/shared'
import { HelpMessage } from 'utils/constants'
import NotConfigured from './components/NotConfigured'
import TypeFallback from '../TypeFallback'
import CIMSSection from 'components/CIMSSection'

const ViewIssueNotifications: React.VFC = () => {
  const { event } = useCIMSNotificationsPanelContext()
  const { recipients, types } = useIssueNotificationsContext()
  const { byIssueType, every } = recipients(event)
  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <CIMSSection
        help={HelpMessage.Notifications.Every(event, 'Issue')}
        title={`Every ${event.name} Event`}
      >
        <RecipientsTags
          noRecipientsContent={<NotConfigured type="Every" />}
          recipients={every}
        />
      </CIMSSection>
      <CIMSSection
        help={HelpMessage.Issues.Notifications.ByIssueType(event)}
        title="Types"
      >
        <CIMSCollapse
          noPanelsContent={<TypeFallback />}
          panels={types
            .sort(alphabeticalSort('name'))
            .map(({ id, name, description }) => {
              const recipients = byIssueType?.find(
                ({ type }) => type.id === id
              )?.recipients
              return {
                key: id,
                header: {
                  type: 'described',
                  name,
                  description,
                },
                children: (
                  <RecipientsTags
                    noRecipientsContent={
                      <NotConfigured type="Type" name={name} />
                    }
                    recipients={recipients}
                  />
                ),
              }
            })}
        />
      </CIMSSection>
    </Space>
  )
}

export default ViewIssueNotifications
